import { styled } from '@mui/material/styles';
import {
    Typography,
    Card,
} from '@mui/material';
import TableCell from '@mui/material/TableCell';
import Paper from '@mui/material/Paper';
import TableHead from '@mui/material/TableHead';
import TextField from '@mui/material/TextField';

export const ContentContainer = styled('div')({
    position: 'relative',
    minHeight: 'calc(100vh - 64px)',
    paddingBottom: '100px',
    overflowY: 'auto',
    marginLeft: 70
});

export const MainContent = styled('div')({
    padding: '20px',
    marginBottom: '20px',

});

export const CenteredCard = styled(Card)({
    maxWidth: '100%',
    margin: '20px',
    marginTop: '80px',
    borderBottom: '2px solid dodgerblue',
    //borderRight: '2px solid dodgerblue',
    marginBottom: '25px'
});

export const StyledTableContainer = styled(Paper)({
    padding: '16px',
    maxWidth: '100%',
    margin: '16px 0',
    overflowX: 'auto',
    boxShadow: 'none',
    borderRadius: '4px',
    backgroundColor: '#FFFFFF', 
    border: 'none',
});

export const StyledTableContainerForDetailed = styled(Paper)({
    padding: '16px',
    maxWidth: '100%',
    margin: '-70px 0',
    overflowX: 'auto',
    boxShadow: 'none',
    borderRadius: '4px',
    backgroundColor: '#FFFFFF', 
    border: 'none',
});

export const HeaderTitle = styled(Typography)({
    flexGrow: 1,
    fontSize: '1.4rem',
    color: '#333',
    fontWeight: 'normal',
    textAlign: 'left',
    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
});

// Styled Table Head
export const StyledTableHead = styled(TableHead)({
    backgroundColor: '#333', 
    color: '#ffffff',
    fontWeight: 'bold',
    borderRadius: '8px 8px 0 0',
    textAlign: 'center',
    '& th': {
        borderBottom: 'none', 
    },
});

// Styled Table Column
export const StyledTableColumn = styled(TableCell)({
    fontWeight: 'bold',
    fontSize: '1rem', 
    textAlign: 'center',
    padding: '12px 16px',
    backgroundColor: '#f0f0f0', 
    borderRight: '1px solid #cccccc', 
    color: '#333',
    borderRadius: '0', 
    '&:last-child': {
        borderRight: 'none', 
    },
    '&:hover': {
        backgroundColor: '#d6d6d6', 
        transition: 'background-color 0.2s ease',
    },
});

// Styled Table Cell
export const StyledTableCell = styled(TableCell)({
    fontSize: '0.965rem', 
    textAlign: 'center',
    padding: '12px 16px',
    backgroundColor: '#ffffff', 
    borderBottom: '1px solid #cccccc', 
    color: '#333',
    borderRadius: '0', 
    '&:hover': {
        backgroundColor: '#f5f5f5', 
        transition: 'background-color 0.2s ease',
    },
});

export const RefreshIcon = styled('img')({
    cursor: 'pointer',
    width: '40px',
    height: '40px',
    transition: 'transform 0.3s ease-in-out',
    '&:hover': {
        transform: 'rotate(360deg)',
    },
});

export const CustomTextField = styled(TextField)({
    '& .MuiInput-root': {
        color: 'dodgerblue',
        fontSize: '1rem',
    },
    '& .MuiInput-underline:after': {
        borderBottomColor: 'dodgerblue',
    },
    '& .MuiInput-underline:before': {
        borderBottomColor: 'dodgerblue',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
        borderBottomColor: 'dodgerblue',
    },
});